import{warn as i}from"../util/warn.js";import e from"./DynamicWidgets.js";export default Object.assign({},e,{name:"AisExperimentalDynamicWidgets",mounted:function(){i("Use AisDynamicWidgets instead of AisExperimentalDynamicWidgets.")}});
//# sourceMappingURL=ExperimentalDynamicWidgets.js.map
